<template>
  <div>
    <div style="width:100%; height:100%; background-color:#00000024; position: absolute; z-index:2;">
        <v-icon style="color:#0000001f;margin-top:10px;font-size:100px;">lock</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LockPage',
}
</script>